import { API_GET_AUTH_TOKEN, LOGIN } from "../constants/urls";
import api from "./api";
import jwt from "./jwt";

export const session = {
    getAccessToken: async function (values) {
        try {
            const res = await api.post(API_GET_AUTH_TOKEN, values, {
                maxRedirects: 0,
            });              
            let bearer = res.headers.get("Authorization");
            if (!bearer) throw new Error("Login Failed.");
            var token = bearer.replace("Bearer ", "");
            jwt.setToken(token);
        } catch (err) {
            throw err;
        }
    }
};